<ng-container thr-parent-form>
    <div class="container">
        <div class="row">
            <div class="col-6 col-md-8 col-lg-6"><!--col-12-->
                <mat-form-field class="full-width no-padding-bottom mt-5" [class.mat-form-field-invalid]="amountCtrl.invalid">
                    <mat-label>{{ 'form.amount-to-subscribe' | translate }}</mat-label>
                    <input
                        type="hidden"
                        name="amount"
                        [min]="minimumInvestment"
                        [max]="maximumInvestment"
                        [(ngModel)]="selectedProduct.order.amount"
                        #amountCtrl="ngModel"
                    />
                    <input
                        matInput
                        #autoNumericDirective="auto-numeric"
                        thr-auto-numeric
                        [placeholder]="'form.hints.amount' | translate"
                        required
                        [disabled]="!editable"
                        [value]="initialAmount"
                        (input)="onAmountChange()"
                    />
                </mat-form-field>
                <div class="mb-5">
                    <mat-hint class="d-block mat-caption" *ngIf="!amountCtrl.errors">
                        <ng-container *ngIf="!!minimumInvestmentMsg && minimumInvestment > 0">
                            {{
                                minimumInvestmentMsg
                                    | translate
                                        : {
                                              value: minimumInvestment | number: '1.0-2'
                                          }
                            }}
                        </ng-container>
                    </mat-hint>
                    <mat-error class="d-block mat-caption" *ngIf="amountCtrl.hasError('min') && !amountCtrl.hasError('required')">
                        <ng-container *ngIf="!!minimumInvestmentMsg">
                            {{
                                minimumInvestmentMsg
                                    | translate
                                        : {
                                              value: minimumInvestment | number: '1.0-2'
                                          }
                            }}
                        </ng-container>
                    </mat-error>
                    <mat-error class="d-block mat-caption" *ngIf="amountCtrl.hasError('max') && !amountCtrl.hasError('required')">
                        {{
                            'form.validation.maximum-amount'
                                | translate
                                    : {
                                          value: maximumInvestment | number: '1.0-2'
                                      }
                        }}
                    </mat-error>
                    <mat-error class="d-block mat-caption" *ngIf="amountCtrl.hasError('required')">
                        {{ 'form.validation.required' | translate }}
                    </mat-error>
                </div>
            </div>
            <!--Nuevo ADV-2351-->
            <div class="col-6 col-md-8 col-lg-6">
                <div class="product-summary">
                 <ng-container *ngIf="canExonerate">
                    <div class="py-4 py-md-0">
                        <label class="mb-0">
                            {{ 'product.convenience' | translate }}
                            <span class="appropriateness ml-4" [class.not-appropriateness]="!selectedProduct.isAppropriateness">
                                <mat-icon>check</mat-icon>
                            </span>
                        </label>
                    </div>

                    <div class="d-flex">
                        <label class="mt-1 mb-0 mt-md-0">{{ 'product.exonerate' | translate }}</label>
                        <mat-radio-group class="ml-4" [disabled]="true" *ngIf="selectedProduct.isAppropriateness">
                            <mat-radio-button color="blue-gray" [value]="false">
                                {{ 'general.no' | translate }}
                            </mat-radio-button>
                            <mat-radio-button class="ml-5" color="blue-gray" [value]="true">
                                {{ 'general.yes' | translate }}
                            </mat-radio-button>
                        </mat-radio-group>
                        <mat-radio-group class="ml-4" name="isExonerated" [disabled]="!editable" [(ngModel)]="selectedProduct.isExonerated" (ngModelChange)="onExonerate()" *ngIf="!selectedProduct.isAppropriateness">
                            <mat-radio-button color="blue-gray" [value]="false">
                                {{ 'general.no' | translate }}
                            </mat-radio-button>
                            <mat-radio-button class="ml-5" color="blue-gray" [value]="true">
                                {{ 'general.yes' | translate }}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>

                 </ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-container>
